<!-- 设备详情 -->
<template>
    <div class="content">
        <div class="equipm xrow ai-c jc-sb">
            <div class="equipm-desc flex2">
                <div class="encoder-bg" :class="Encoder.InternalModel"></div>
                <div class="equ-cc">
                    <h3>智能感知监测站</h3>
                    <p>
                        <span>型号：{{Encoder.SN}}</span>
                        <span>编码：{{Encoder.NumberCode}}</span>
                        <!-- <span>地域：{{land.Province+land.City+land.County}}</span> -->
                    </p>
                </div>
            </div>
            <div class="equipm-status flex3 mgl30 xrow ai-c jc-s pdh20">
                <div class="equ-net pdh20">
                    <i>
                        <el-image :src="require('../../../assets/status/run.png')" v-if="Encoder.AlarmEvent===0"></el-image>
                        <el-image :src="require('../../../assets/status/stop.png')" v-else></el-image>
                    </i>
                    <b>{{Encoder.AlarmState===0?'运行中':'离线'}}</b>
                    <span>网络类型：4G</span>
                </div>
                <div class="equ-sensor xrow ai-c jc-c pdh20">
                    <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">智能监测</b><i class="mgt25"><img src="../../../assets/category/sense-auto.png"></i><span class="mgt20 color-m1f fs14">{{SensorsAuto.length}}个传感器</span>
                    </div>
                    <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">影像监测</b><i class="mgt25"><img src="../../../assets/category/sense-camera.png"></i><span class="mgt20 color-m1f fs14">{{SensorsPicture.length}}个传感器</span>
                    </div>
                    <!-- <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">移动</b><i class="mgt25"><img src="../../../assets/category/sense-map.png"></i><span class="mgt20 color-m1f fs14">{{Sensors.waters.length}}个传感器</span>
                    </div> -->
                </div>
                <div class="equ-alarm xrow ai-c- jc-s pdv20">
                    <div class="status mgr10 pd30 xcol ai-c jc-sb w140">
                        <i><img src="../../../assets/status/ll-7.png"></i><span>无异常</span>
                    </div>
                    <div class="alarm mgr10 pd30 xcol ai-c jc-sb w140">
                        <i>{{AlarmCount}}</i><span>报警事件</span>
                    </div>
                    <div class="location pd30 xcol ai-c jc-sb w140">
                        <i><img src="../../../assets/status/ll-8.png"></i><span>盐城市</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="monitor mgt20">
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh20 mgt20 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/sense-item-auto.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">监测实时数据</span>
                </div>
                <div class="pl-content">
                    <el-row>
                        <el-col :span="3" v-for="(item,index) in SensorsAuto" :key="index">
                            <div class="sensor-item xcol ai-c jc-c">
                                <img :src="require('../../../assets/icon/default1.png')">
                                <div class="color-m16 fs24 fw-bd pdv15">{{item.GuagedText}}</div>
                                <div class="color-m5b fs16 pdv5">{{item.Alias}}</div>
                                <i class="el-icon-time"></i>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh20 mgt20 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/sense-item-camera.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">影像监测数据</span>
                </div>
                <div class="pl-content">
                    <el-row>
                        <el-col :span="3" v-for="(item,index) in SensorsPicture" :key="index">
                            <div class="sensor-item xcol ai-c jc-c">
                                <img :src="require('../../../assets/icon/default1.png')">
                                <div class="color-m16 fs24 fw-bd pdv15">{{item.GuagedText}}</div>
                                <div class="color-m5b fs16 pdv5">{{item.Alias}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 mgt20 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/te-2.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">作物主要生育期长势、推荐施肥、估产量、品质等分析</span>
                </div>
                <div class="pl-content pdt20">
                    <documentword :encoderId="EncoderId"></documentword>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { SensorKind } from '@/common/pes.utils.js'
import documentword from '@/components/document-word'
import config from './config.js'
export default {
    components: { documentword },
    data() {
        return {
            EncoderId: '',
            Encoder: {
                AlarmState: 1
            },
            Sensors: {
                airs: [],
                soils: [],
                waters: []
            },
            AlarmCount: 0,
            Location: '',
            AirCount: 0,
            SoilCount: 0,
            WaterCount: 0,

            defaultImg: '../../../assets/icon/default0.png'
        }
    },

    computed: {
       // ...mapState(['encoders', 'land']),
        SensorsAuto() {
            let CalcSensor = []
            config.SensorConfig.filter(t => t.Category === '智能监测').forEach(
                (cfg, index) => {
                    CalcSensor.push(Object.assign(cfg, { Install: true }))
                }
            )
            return CalcSensor
        },
        SensorsPicture() {
            let CalcSensor = []
            config.SensorConfig.filter(t => t.Category === '影像监测').forEach(
                (cfg, index) => {
                    CalcSensor.push(Object.assign(cfg, { Install: true }))
                }
            )
            return CalcSensor
        }
    },

    mounted() {
        this.loadData()
    },

    methods: {
        defImg() {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        },
        loadData() {
            this.EncoderId = this.$route.params.id
            this.Encoder = this.encoders.find(
                t => t.EncoderId === this.EncoderId
            )
        },
        getSensors(sensors) {
            var cfg = { airs: [], soils: [], waters: [], all: [] }
            cfg.all = [].concat(sensors)
            for (var p in sensors) {
                var item = sensors[p]

                var kind = SensorKind[item.Resource]
                if (!kind) continue
                Object.assign(item, kind)

                switch (item.group) {
                    case 0:
                        cfg.airs.push(item)
                        break
                    case 2:
                        cfg.soils.push(item)
                        break
                    case 1:
                        cfg.waters.push(item)
                        break
                    default:
                        break
                }
            }
            return cfg
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}
.color-m09 {
    color: #090e15;
}
.color-m16 {
    color: #162437;
}
.color-m5b {
    color: #5b6580;
}
.color-m27 {
    color: #273447;
}
.color-m1f {
    color: #1f2d3f;
}
.equipm {
    position: relative;
    overflow: hidden;
    .equipm-desc {
        background: url(../../../assets/status/m-3.png) no-repeat;
        background-size: 100% 100%;
        height: 200px;
        padding-left: 25px;
        position: relative;
        z-index: 12;
        .encoder-bg {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 60%;
            z-index: -1;
            &::before {
                content: '';
                display: inline-block;
                width: 100%;
                height: 100%;
                background: url(../../../assets/encoder/sense.png) no-repeat;
                background-position: right top;
                background-size: 70%;
            }
        }
        .equ-cc {
            height: 200px;
            text-align: left;
            h3 {
                font-weight: bold;
                font-size: 28px;
                color: #fff;
                padding-top: 35px;
                letter-spacing: 2px;
            }
            p {
                margin: 0;
                margin-top: 15px;
                span {
                    display: block;
                    font-size: 16px;
                    color: #fff;
                    line-height: 24px;
                }
            }
        }
    }
    .equipm-status {
        background-color: #fff;
        height: 200px;
        border-radius: 10px;
        .equ-net {
            text-align: center;
            b {
                display: block;
                font-size: 18px;
                color: #273447;
                margin: 10px 0;
                margin-top: 15px;
            }
            span {
                display: block;
                color: #8892a0;
                font-size: 14px;
                min-width: 100px;
            }
            i {
                display: block;
                padding-top: 20px;
            }
        }
        .equ-sensor {
            border-left: solid 1px #f0f0f0;
            margin-top: 21px;
        }
        .equ-alarm {
            height: 200px;
            text-align: center;
            margin: 0;
            .status {
                background: url(../../../assets/status/ll-4.png) no-repeat;
                background-size: 100% 100%;
            }
            .alarm {
                background: url(../../../assets/status/ll-5.png) no-repeat;
                background-size: 100% 100%;
            }
            .location {
                background: url(../../../assets/status/ll-6.png) no-repeat;
                background-size: 100% 100%;
            }
            i {
                display: inline-block;
                width: 48px;
                height: 48px;
                line-height: 48px;
                color: #fff;
                font-size: 42px;
                font-weight: bold;
            }
            span {
                display: block;
                font-weight: bold;
                font-size: 16px;
                color: #fff;
                margin-top: 20px;
            }
        }
    }
}
.sensor-item {
    padding: 10px 10px;
    margin-top: 20px;
    position: relative;
    i {
        position: absolute;
        top: 5px;
        right: 5px;
        color: rgba(176, 185, 210, 0.8);
    }
    &:hover {
        background: rgba(176, 185, 210, 0.1);
    }
    &:after {
        content: '';
        position: absolute;
        height: 80%;
        width: 1px;
        top: 10%;
        right: 0px;
        background: #ecf1f9;
    }
}
</style>
